import { css, keyframes, ThemeProvider, Global } from '@emotion/react';
import _styled from '@emotion/styled/base';
import React__default, { useLayoutEffect, useEffect, createElement } from 'react';
import { differenceInHours, startOfDay, format, addDays, roundToNearestMinutes, getTime as getTime$1, differenceInMinutes, isToday, startOfToday } from 'date-fns';
import { useDebouncedCallback } from 'use-debounce';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject;
var globalStyles = /*#__PURE__*/css(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  @import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap\");\n\n  .planby {\n    font-family: \"Inter\", system-ui, -apple-system,\n      /* Firefox supports this but not yet system-ui */ \"Segoe UI\", Roboto,\n      Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\"; /* 2 */\n  }\n"])));

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ra9c6c4"
} : {
  target: "e1ra9c6c4",
  label: "Container"
})("padding:5px;height:", function (_ref) {
  var height = _ref.height;
  return height ? height + "px" : "100%";
}, ";width:", function (_ref2) {
  var width = _ref2.width;
  return width ? width + "px" : "100%";
}, ";*,::before,::after{box-sizing:border-box;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Wrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ra9c6c3"
} : {
  target: "e1ra9c6c3",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "qjsha7",
  styles: "height:100%;width:100%;display:flex;flex-direction:column;position:relative;border-radius:6px;overflow:hidden"
} : {
  name: "qjsha7",
  styles: "height:100%;width:100%;display:flex;flex-direction:column;position:relative;border-radius:6px;overflow:hidden",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var ScrollBox = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ra9c6c2"
} : {
  target: "e1ra9c6c2",
  label: "ScrollBox"
})("height:100%;width:100%;position:relative;overflow:auto;scroll-behavior:smooth;background:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.primary[900];
}, ";", function (_ref4) {
  var isRTL = _ref4.isRTL;
  return isRTL && "transform: scale(-1,1)";
}, ";::-webkit-scrollbar{width:10px;height:10px;}::-webkit-scrollbar-thumb{background:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.scrollbar.thumb.bg;
}, ";border:10px none ", function (_ref6) {
  var theme = _ref6.theme;
  return theme.white;
}, ";border-radius:20px;}::-webkit-scrollbar-thumb:hover{background:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.white;
}, ";}::-webkit-scrollbar-track{background:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.primary[900];
}, ";border:22px none ", function (_ref9) {
  var theme = _ref9.theme;
  return theme.white;
}, ";border-radius:0px;}::-webkit-scrollbar-corner{background:", function (_ref10) {
  var theme = _ref10.theme;
  return theme.primary[900];
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Box = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ra9c6c1"
} : {
  target: "e1ra9c6c1",
  label: "Box"
})("position:absolute;height:", function (_ref11) {
  var height = _ref11.height;
  return height;
}, "px;width:", function (_ref12) {
  var width = _ref12.width;
  return width;
}, "px;top:", function (_ref13) {
  var _ref13$top = _ref13.top,
      top = _ref13$top === void 0 ? 0 : _ref13$top;
  return top;
}, "px;background:", function (_ref14) {
  var theme = _ref14.theme;
  return theme.primary[900];
}, ";z-index:90;", function (_ref15) {
  var isRTL = _ref15.isRTL,
      _ref15$left = _ref15.left,
      left = _ref15$left === void 0 ? 0 : _ref15$left;
  return isRTL ? "right:0px;" : " left: " + left + "px";
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Content = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ra9c6c0"
} : {
  target: "e1ra9c6c0",
  label: "Content"
})("background:", function (_ref16) {
  var theme = _ref16.theme;
  return theme.primary[900];
}, ";height:", function (_ref17) {
  var height = _ref17.height;
  return height;
}, "px;width:", function (_ref18) {
  var width = _ref18.width;
  return width;
}, "px;position:relative;left:", function (_ref19) {
  var isSidebar = _ref19.isSidebar,
      sidebarWidth = _ref19.sidebarWidth;
  return isSidebar ? sidebarWidth : 0;
}, "px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Box$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dhe7bi0"
} : {
  target: "e1dhe7bi0",
  label: "Box"
})("position:sticky;width:", function (_ref) {
  var width = _ref.width;
  return width;
}, "px;float:left;bottom:", function (_ref2) {
  var bottom = _ref2.bottom;
  return bottom;
}, "px;left:0;z-index:10;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.primary[900];
}, ";", function (_ref4) {
  var isRTL = _ref4.isRTL;
  return isRTL && "transform: scale(-1,1)";
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoYW5uZWxzLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDOEIiLCJmaWxlIjoiQ2hhbm5lbHMuc3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkL21hY3JvXCI7XHJcbmV4cG9ydCBjb25zdCBCb3ggPSBzdHlsZWQuZGl2IGBcbiAgcG9zaXRpb246IHN0aWNreTtcbiAgd2lkdGg6ICR7KHsgd2lkdGggfSkgPT4gd2lkdGh9cHg7XG4gIGZsb2F0OiBsZWZ0O1xuICBib3R0b206ICR7KHsgYm90dG9tIH0pID0+IGJvdHRvbX1weDtcbiAgbGVmdDogMDtcbiAgei1pbmRleDogMTA7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUucHJpbWFyeVs5MDBdfTtcblxuICAkeyh7IGlzUlRMIH0pID0+IGlzUlRMICYmIGB0cmFuc2Zvcm06IHNjYWxlKC0xLDEpYH07XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1DaGFubmVscy5zdHlsZXMuanMubWFwIl19 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ChannelBox = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "edhgbii1"
} : {
  target: "edhgbii1",
  label: "ChannelBox"
})("position:absolute;top:", function (_ref) {
  var top = _ref.top;
  return top;
}, "px;height:", function (_ref2) {
  var height = _ref2.height;
  return height;
}, "px;width:100%;display:flex;align-items:center;justify-content:center;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.primary[900];
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoYW5uZWwuc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNxQyIsImZpbGUiOiJDaGFubmVsLnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZC9tYWNyb1wiO1xyXG5leHBvcnQgY29uc3QgQ2hhbm5lbEJveCA9IHN0eWxlZC5kaXYgYFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogJHsoeyB0b3AgfSkgPT4gdG9wfXB4O1xuICBoZWlnaHQ6ICR7KHsgaGVpZ2h0IH0pID0+IGhlaWdodH1weDtcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnByaW1hcnlbOTAwXX07XG5gO1xyXG5leHBvcnQgY29uc3QgQ2hhbm5lbExvZ28gPSBzdHlsZWQuaW1nIGBcbiAgbWF4LWhlaWdodDogNjBweDtcbiAgbWF4LXdpZHRoOiA2MHB4O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1DaGFubmVsLnN0eWxlcy5qcy5tYXAiXX0= */"));
var ChannelLogo = /*#__PURE__*/_styled("img", process.env.NODE_ENV === "production" ? {
  target: "edhgbii0"
} : {
  target: "edhgbii0",
  label: "ChannelLogo"
})(process.env.NODE_ENV === "production" ? {
  name: "vfop22",
  styles: "max-height:60px;max-width:60px;position:relative"
} : {
  name: "vfop22",
  styles: "max-height:60px;max-width:60px;position:relative",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoYW5uZWwuc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVdzQyIsImZpbGUiOiJDaGFubmVsLnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZC9tYWNyb1wiO1xyXG5leHBvcnQgY29uc3QgQ2hhbm5lbEJveCA9IHN0eWxlZC5kaXYgYFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogJHsoeyB0b3AgfSkgPT4gdG9wfXB4O1xuICBoZWlnaHQ6ICR7KHsgaGVpZ2h0IH0pID0+IGhlaWdodH1weDtcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnByaW1hcnlbOTAwXX07XG5gO1xyXG5leHBvcnQgY29uc3QgQ2hhbm5lbExvZ28gPSBzdHlsZWQuaW1nIGBcbiAgbWF4LWhlaWdodDogNjBweDtcbiAgbWF4LXdpZHRoOiA2MHB4O1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1DaGFubmVsLnN0eWxlcy5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ProgramBox = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f8qikj6"
} : {
  target: "e1f8qikj6",
  label: "ProgramBox"
})("position:absolute;padding:", function (_ref) {
  var width = _ref.width;
  return width === 0 ? 0 : 4;
}, "px;overflow:hidden;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByb2dyYW0uc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNxQyIsImZpbGUiOiJQcm9ncmFtLnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZC9tYWNyb1wiO1xyXG5leHBvcnQgY29uc3QgUHJvZ3JhbUJveCA9IHN0eWxlZC5kaXYgYFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHBhZGRpbmc6ICR7KHsgd2lkdGggfSkgPT4gKHdpZHRoID09PSAwID8gMCA6IDQpfXB4O1xuICBvdmVyZmxvdzogaGlkZGVuO1xuYDtcclxuZXhwb3J0IGNvbnN0IFByb2dyYW1Db250ZW50ID0gc3R5bGVkLmRpdiBgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogZmxleDtcbiAgZm9udC1zaXplOiAxMXB4O1xuICBoZWlnaHQ6IDEwMCU7XG4gIGJvcmRlci1yYWRpdXM6IDhweDtcbiAgcGFkZGluZzogMTBweCAkeyh7IHdpZHRoIH0pID0+ICh3aWR0aCA8IDMwID8gNCA6IDIwKX1weDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICB0cmFuc2l0aW9uOiBhbGwgMC40cyBlYXNlLWluLW91dDtcbiAgei1pbmRleDogMTtcbiAgYmFja2dyb3VuZDogJHsoeyB0aGVtZTogeyBwcmltYXJ5IH0gfSkgPT4gYGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgJHtwcmltYXJ5WzYwMF19LCAke3ByaW1hcnlbNjAwXX0pYH07XG4gICY6aG92ZXIge1xuICAgIGJhY2tncm91bmQ6ICR7KHsgdGhlbWU6IHsgZ3JhZGllbnQgfSB9KSA9PiBgbGluZWFyLWdyYWRpZW50KHRvIHJpZ2h0LCAke2dyYWRpZW50LmJsdWVbOTAwXX0sICR7Z3JhZGllbnQuYmx1ZVs2MDBdfSlgfTtcbiAgfVxuXG4gICR7KHsgaXNMaXZlLCB0aGVtZTogeyBncmFkaWVudCB9IH0pID0+IGlzTGl2ZSAmJlxyXG4gICAgYGJhY2tncm91bmQ6IGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgJHtncmFkaWVudC5ibHVlWzkwMF19LCAke2dyYWRpZW50LmJsdWVbNjAwXX0sJHtncmFkaWVudC5ibHVlWzMwMF19KWB9XG5gO1xyXG5leHBvcnQgY29uc3QgUHJvZ3JhbUZsZXggPSBzdHlsZWQuZGl2IGBcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1zdGFydDtcbmA7XHJcbmNvbnN0IEVsaXBzaXMgPSBgXG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuYDtcclxuZXhwb3J0IGNvbnN0IFByb2dyYW1UaXRsZSA9IHN0eWxlZC5wIGBcbiAgZm9udC1zaXplOiAxNHB4O1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuICBtYXJnaW4tdG9wOiAwO1xuICBtYXJnaW4tYm90dG9tOiA1cHg7XG4gIGZvbnQtd2VpZ2h0OiA1MDA7XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmdyZXlbMzAwXX07XG4gICR7RWxpcHNpc31cbmA7XHJcbmV4cG9ydCBjb25zdCBQcm9ncmFtVGV4dCA9IHN0eWxlZC5zcGFuIGBcbiAgZGlzcGxheTogYmxvY2s7XG4gIGZvbnQtc2l6ZTogMTIuNXB4O1xuICBmb250LXdlaWdodDogNDAwO1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS50ZXh0LmdyZXlbNTAwXX07XG4gIHRleHQtYWxpZ246IGxlZnQ7XG4gICR7RWxpcHNpc31cbmA7XHJcbmV4cG9ydCBjb25zdCBQcm9ncmFtSW1hZ2UgPSBzdHlsZWQuaW1nIGBcbiAgbWFyZ2luLXJpZ2h0OiAxNXB4O1xuICBib3JkZXItcmFkaXVzOiA2cHg7XG4gIHdpZHRoOiAxMDBweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBQcm9ncmFtU3RhY2sgPSBzdHlsZWQuZGl2IGBcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgJHsoeyBpc1JUTCB9KSA9PiBpc1JUTCAmJlxyXG4gICAgYHRyYW5zZm9ybTogc2NhbGUoLTEsMSk7IFxuICAgICBkaXNwbGF5OiBmbGV4OyBcbiAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjsgXG4gICAgIGFsaWduLWl0ZW1zOiBmbGV4LWVuZGB9O1xuYDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9UHJvZ3JhbS5zdHlsZXMuanMubWFwIl19 */"));
var ProgramContent = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f8qikj5"
} : {
  target: "e1f8qikj5",
  label: "ProgramContent"
})("position:relative;display:flex;font-size:11px;height:100%;border-radius:8px;padding:10px ", function (_ref2) {
  var width = _ref2.width;
  return width < 30 ? 4 : 20;
}, "px;overflow:hidden;cursor:pointer;transition:all 0.4s ease-in-out;z-index:1;background:", function (_ref3) {
  var primary = _ref3.theme.primary;
  return "linear-gradient(to right, " + primary[600] + ", " + primary[600] + ")";
}, ";&:hover{background:", function (_ref4) {
  var gradient = _ref4.theme.gradient;
  return "linear-gradient(to right, " + gradient.blue[900] + ", " + gradient.blue[600] + ")";
}, ";}", function (_ref5) {
  var isLive = _ref5.isLive,
      gradient = _ref5.theme.gradient;
  return isLive && "background: linear-gradient(to right, " + gradient.blue[900] + ", " + gradient.blue[600] + "," + gradient.blue[300] + ")";
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var ProgramFlex = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f8qikj4"
} : {
  target: "e1f8qikj4",
  label: "ProgramFlex"
})(process.env.NODE_ENV === "production" ? {
  name: "6wjsds",
  styles: "width:100%;display:flex;justify-content:flex-start"
} : {
  name: "6wjsds",
  styles: "width:100%;display:flex;justify-content:flex-start",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
var Elipsis = "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var ProgramTitle = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e1f8qikj3"
} : {
  target: "e1f8qikj3",
  label: "ProgramTitle"
})("font-size:14px;text-align:left;margin-top:0;margin-bottom:5px;font-weight:500;color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.grey[300];
}, ";", Elipsis, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var ProgramText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1f8qikj2"
} : {
  target: "e1f8qikj2",
  label: "ProgramText"
})("display:block;font-size:12.5px;font-weight:400;color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.text.grey[500];
}, ";text-align:left;", Elipsis, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByb2dyYW0uc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRDdUMiLCJmaWxlIjoiUHJvZ3JhbS5zdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWQvbWFjcm9cIjtcclxuZXhwb3J0IGNvbnN0IFByb2dyYW1Cb3ggPSBzdHlsZWQuZGl2IGBcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICBwYWRkaW5nOiAkeyh7IHdpZHRoIH0pID0+ICh3aWR0aCA9PT0gMCA/IDAgOiA0KX1weDtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbmA7XHJcbmV4cG9ydCBjb25zdCBQcm9ncmFtQ29udGVudCA9IHN0eWxlZC5kaXYgYFxuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZvbnQtc2l6ZTogMTFweDtcbiAgaGVpZ2h0OiAxMDAlO1xuICBib3JkZXItcmFkaXVzOiA4cHg7XG4gIHBhZGRpbmc6IDEwcHggJHsoeyB3aWR0aCB9KSA9PiAod2lkdGggPCAzMCA/IDQgOiAyMCl9cHg7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgdHJhbnNpdGlvbjogYWxsIDAuNHMgZWFzZS1pbi1vdXQ7XG4gIHotaW5kZXg6IDE7XG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWU6IHsgcHJpbWFyeSB9IH0pID0+IGBsaW5lYXItZ3JhZGllbnQodG8gcmlnaHQsICR7cHJpbWFyeVs2MDBdfSwgJHtwcmltYXJ5WzYwMF19KWB9O1xuICAmOmhvdmVyIHtcbiAgICBiYWNrZ3JvdW5kOiAkeyh7IHRoZW1lOiB7IGdyYWRpZW50IH0gfSkgPT4gYGxpbmVhci1ncmFkaWVudCh0byByaWdodCwgJHtncmFkaWVudC5ibHVlWzkwMF19LCAke2dyYWRpZW50LmJsdWVbNjAwXX0pYH07XG4gIH1cblxuICAkeyh7IGlzTGl2ZSwgdGhlbWU6IHsgZ3JhZGllbnQgfSB9KSA9PiBpc0xpdmUgJiZcclxuICAgIGBiYWNrZ3JvdW5kOiBsaW5lYXItZ3JhZGllbnQodG8gcmlnaHQsICR7Z3JhZGllbnQuYmx1ZVs5MDBdfSwgJHtncmFkaWVudC5ibHVlWzYwMF19LCR7Z3JhZGllbnQuYmx1ZVszMDBdfSlgfVxuYDtcclxuZXhwb3J0IGNvbnN0IFByb2dyYW1GbGV4ID0gc3R5bGVkLmRpdiBgXG4gIHdpZHRoOiAxMDAlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQ7XG5gO1xyXG5jb25zdCBFbGlwc2lzID0gYFxuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbmA7XHJcbmV4cG9ydCBjb25zdCBQcm9ncmFtVGl0bGUgPSBzdHlsZWQucCBgXG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgdGV4dC1hbGlnbjogbGVmdDtcbiAgbWFyZ2luLXRvcDogMDtcbiAgbWFyZ2luLWJvdHRvbTogNXB4O1xuICBmb250LXdlaWdodDogNTAwO1xuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5ncmV5WzMwMF19O1xuICAke0VsaXBzaXN9XG5gO1xyXG5leHBvcnQgY29uc3QgUHJvZ3JhbVRleHQgPSBzdHlsZWQuc3BhbiBgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICBmb250LXNpemU6IDEyLjVweDtcbiAgZm9udC13ZWlnaHQ6IDQwMDtcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudGV4dC5ncmV5WzUwMF19O1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuICAke0VsaXBzaXN9XG5gO1xyXG5leHBvcnQgY29uc3QgUHJvZ3JhbUltYWdlID0gc3R5bGVkLmltZyBgXG4gIG1hcmdpbi1yaWdodDogMTVweDtcbiAgYm9yZGVyLXJhZGl1czogNnB4O1xuICB3aWR0aDogMTAwcHg7XG5gO1xyXG5leHBvcnQgY29uc3QgUHJvZ3JhbVN0YWNrID0gc3R5bGVkLmRpdiBgXG4gIG92ZXJmbG93OiBoaWRkZW47XG4gICR7KHsgaXNSVEwgfSkgPT4gaXNSVEwgJiZcclxuICAgIGB0cmFuc2Zvcm06IHNjYWxlKC0xLDEpOyBcbiAgICAgZGlzcGxheTogZmxleDsgXG4gICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47IFxuICAgICBhbGlnbi1pdGVtczogZmxleC1lbmRgfTtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVByb2dyYW0uc3R5bGVzLmpzLm1hcCJdfQ== */"));
var ProgramImage = /*#__PURE__*/_styled("img", process.env.NODE_ENV === "production" ? {
  target: "e1f8qikj1"
} : {
  target: "e1f8qikj1",
  label: "ProgramImage"
})(process.env.NODE_ENV === "production" ? {
  name: "1azmhcm",
  styles: "margin-right:15px;border-radius:6px;width:100px"
} : {
  name: "1azmhcm",
  styles: "margin-right:15px;border-radius:6px;width:100px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
var ProgramStack = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f8qikj0"
} : {
  target: "e1f8qikj0",
  label: "ProgramStack"
})("overflow:hidden;", function (_ref8) {
  var isRTL = _ref8.isRTL;
  return isRTL && "transform: scale(-1,1); \n     display: flex; \n     flex-direction: column; \n     align-items: flex-end";
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

// Dimensions
var DAY_WIDTH = 7200;
var HOUR_IN_MINUTES = 60;
var TIMELINE_HEIGHT = 60;
var SIDEBAR_WIDTH = 100;
var ITEM_HEIGHT = 80;
var ITEM_OVERSCAN = ITEM_HEIGHT; // Debounce

var DEBOUNCE_WAIT = 100;
var DEBOUNCE_WAIT_MAX = 100; // Program refresh

var PROGRAM_REFRESH = 120000; // Theme
var TIME_FORMAT = {
  DEFAULT: "yyyy-MM-dd HH:mm:ss",
  DATE: "yyyy-MM-dd",
  HOURS_MIN: "HH:mm",
  BASE_HOURS_TIME: "h:mm a"
};

var omit = function omit(obj) {
  var result = _extends({}, obj);

  for (var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    props[_key - 1] = arguments[_key];
  }

  for (var _i = 0, _props = props; _i < _props.length; _i++) {
    var property = _props[_i];
    delete result[property];
  }

  return result;
};
var generateArray = function generateArray(num) {
  return new Array(num).fill("");
};
var getProgramOptions = function getProgramOptions(program) {
  var _program$position = program.position,
      width = _program$position.width,
      height = _program$position.height,
      top = _program$position.top,
      left = _program$position.left;
  return _extends({}, program, {
    position: {
      width: width,
      height: height,
      top: top,
      left: left
    }
  });
};
var useIsomorphicLayoutEffect = function useIsomorphicLayoutEffect() {
  return typeof window !== "undefined" ? useLayoutEffect : useEffect;
};
var getDate = function getDate(date) {
  return new Date(date);
};

var abs = function abs(num) {
  return Math.abs(num);
};

var getDayWidthResources = function getDayWidthResources(_ref) {
  var dayWidth = _ref.dayWidth,
      startDate = _ref.startDate,
      endDate = _ref.endDate;
  var startDateTime = getDate(startDate);
  var endDateTime = getDate(endDate);

  if (endDateTime < startDateTime) {
    console.error("Invalid endDate property. Value of endDate must be greater than startDate. Props: startDateTime: " + startDateTime + ", endDateTime: " + endDateTime);
  }

  var offsetStartHoursRange = differenceInHours(startDateTime, startOfDay(startDateTime));
  var numberOfHoursInDay = differenceInHours(endDateTime, startDateTime);
  var hourWidth = Math.floor(dayWidth / numberOfHoursInDay);
  var newDayWidth = hourWidth * numberOfHoursInDay;
  return {
    hourWidth: abs(hourWidth),
    dayWidth: abs(newDayWidth),
    numberOfHoursInDay: abs(numberOfHoursInDay),
    offsetStartHoursRange: abs(offsetStartHoursRange)
  };
};

var getTime = function getTime(date) {
  return new Date(date).getTime();
};

var getLiveStatus = function getLiveStatus(since, till) {
  var nowTime = getTime(new Date());
  var sinceTime = getTime(since);
  var sinceTill = getTime(till);
  return nowTime >= sinceTime && sinceTill > nowTime;
};
var formatTime = function formatTime(date) {
  return format(new Date(date), TIME_FORMAT.DEFAULT).replace(/\s/g, "T");
};
var roundToMinutes = function roundToMinutes(date) {
  return roundToNearestMinutes(new Date(date));
};
var isYesterday = function isYesterday(since, startDate) {
  var sinceTime = getTime(new Date(since));
  var startDateTime = getTime(new Date(startDate));
  return startDateTime > sinceTime;
};
var isFutureTime = function isFutureTime(date) {
  var dateTime = getTime(new Date(date));
  var now = getTime(new Date());
  return dateTime > now;
};
var getTimeRangeDates = function getTimeRangeDates(startDate, endDate) {
  var endDateValue = endDate;

  if (endDate === "") {
    endDateValue = formatTime(startOfDay(addDays(new Date(startDate), 1)));
  }

  return {
    startDate: startDate,
    endDate: endDateValue
  };
};

var getItemDiffWidth = function getItemDiffWidth(diff, hourWidth) {
  return diff * hourWidth / HOUR_IN_MINUTES;
};

var getPositionX = function getPositionX(since, till, startDate, endDate, hourWidth) {
  var isTomorrow = getTime$1(getDate(till)) > getTime$1(getDate(endDate));
  var isYesterday = getTime$1(getDate(since)) < getTime$1(getDate(startDate)); // When time range is set to 1 hour and program time is greater than 1 hour

  if (isYesterday && isTomorrow) {
    var _diffTime = differenceInMinutes(roundToMinutes(getDate(endDate)), getDate(startDate));

    return getItemDiffWidth(_diffTime, hourWidth);
  }

  if (isYesterday) {
    var _diffTime2 = differenceInMinutes(roundToMinutes(getDate(till)), getDate(startDate));

    return getItemDiffWidth(_diffTime2, hourWidth);
  }

  if (isTomorrow) {
    var _diffTime3 = differenceInMinutes(getDate(endDate), roundToMinutes(getDate(since)));

    if (_diffTime3 < 0) return 0;
    return getItemDiffWidth(_diffTime3, hourWidth);
  }

  var diffTime = differenceInMinutes(roundToMinutes(getDate(till)), roundToMinutes(getDate(since)));
  return getItemDiffWidth(diffTime, hourWidth);
}; // -------- Channel position in the Epg --------

var getChannelPosition = function getChannelPosition(channelIndex, itemHeight) {
  var top = itemHeight * channelIndex;
  var position = {
    top: top,
    height: itemHeight
  };
  return position;
}; // -------- Program position in the Epg --------

var getProgramPosition = function getProgramPosition(program, channelIndex, itemHeight, hourWidth, startDate, endDate) {
  var item = _extends({}, program, {
    since: formatTime(program.since),
    till: formatTime(program.till)
  });

  var isYesterday$1 = isYesterday(item.since, startDate);
  var width = getPositionX(item.since, item.till, startDate, endDate, hourWidth);
  var top = itemHeight * channelIndex;
  var left = getPositionX(startDate, item.since, startDate, endDate, hourWidth);
  var edgeEnd = getPositionX(startDate, item.till, startDate, endDate, hourWidth);
  if (isYesterday$1) left = 0; // If item has negative top position, it means that it is not visible in this day

  if (top < 0) width = 0;
  var position = {
    width: width,
    height: itemHeight,
    top: top,
    left: left,
    edgeEnd: edgeEnd
  };
  return {
    position: position,
    data: item
  };
};
var getConvertedPrograms = function getConvertedPrograms(_ref) {
  var data = _ref.data,
      channels = _ref.channels,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      itemHeight = _ref.itemHeight,
      hourWidth = _ref.hourWidth;
  return data.map(function (next) {
    var channelIndex = channels.findIndex(function (_ref2) {
      var uuid = _ref2.uuid;
      return uuid === next.channelUuid;
    });
    return getProgramPosition(next, channelIndex, itemHeight, hourWidth, startDate, endDate);
  }, []);
}; // -------- Converted channels with position data --------

var getConvertedChannels = function getConvertedChannels(channels, itemHeight) {
  return channels.map(function (channel, index) {
    return _extends({}, channel, {
      position: getChannelPosition(index, itemHeight)
    });
  });
}; // -------- Dynamic virtual program visibility in the EPG --------

var getItemVisibility = function getItemVisibility(position, scrollY, scrollX, containerHeight, containerWidth, itemOverscan) {
  if (position.width <= 0) {
    return false;
  }

  if (scrollY > position.top + itemOverscan * 3) {
    return false;
  }

  if (scrollY + containerHeight <= position.top) {
    return false;
  }

  if (scrollX + containerWidth >= position.left && scrollX <= position.edgeEnd) {
    return true;
  }

  return false;
};
var getSidebarItemVisibility = function getSidebarItemVisibility(position, scrollY, containerHeight, itemOverscan) {
  if (scrollY > position.top + itemOverscan * 3) {
    return false;
  }

  if (scrollY + containerHeight <= position.top) {
    return false;
  }

  return true;
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var TimelineTime = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "ebfc5084"
} : {
  target: "ebfc5084",
  label: "TimelineTime"
})("color:", function (_ref) {
  var theme = _ref.theme;
  return theme.text.grey[300];
}, ";position:absolute;top:18px;left:", function (_ref2) {
  var isRTL = _ref2.isRTL,
      isBaseTimeFormat = _ref2.isBaseTimeFormat;
  return isRTL && isBaseTimeFormat ? "-32" : "-18";
}, "px;", function (_ref3) {
  var isRTL = _ref3.isRTL;
  return isRTL && "transform: scale(-1,1)";
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRpbWVsaW5lLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHd0MiLCJmaWxlIjoiVGltZWxpbmUuc3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkL21hY3JvXCI7XHJcbi8vIEltcG9ydCBoZWxlcHJzXHJcbmltcG9ydCB7IElURU1fSEVJR0hUIH0gZnJvbSBcIi4uL2hlbHBlcnNcIjtcclxuZXhwb3J0IGNvbnN0IFRpbWVsaW5lVGltZSA9IHN0eWxlZC5zcGFuIGBcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudGV4dC5ncmV5WzMwMF19O1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMThweDtcbiAgbGVmdDogJHsoeyBpc1JUTCwgaXNCYXNlVGltZUZvcm1hdCB9KSA9PiBpc1JUTCAmJiBpc0Jhc2VUaW1lRm9ybWF0ID8gXCItMzJcIiA6IFwiLTE4XCJ9cHg7XG5cbiAgJHsoeyBpc1JUTCB9KSA9PiBpc1JUTCAmJiBgdHJhbnNmb3JtOiBzY2FsZSgtMSwxKWB9O1xuYDtcclxuZXhwb3J0IGNvbnN0IFRpbWVsaW5lRGl2aWRlcnMgPSBzdHlsZWQuZGl2IGBcbiAgaGVpZ2h0OiAxMDAlO1xuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiByZXBlYXQoNCwgMWZyKTtcbiAgYWxpZ24taXRlbXM6IGVuZDtcbiAgcGFkZGluZy1ib3R0b206IDZweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZURpdmlkZXIgPSBzdHlsZWQuZGl2IGBcbiAgYmFja2dyb3VuZDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS50aW1lbGluZS5kaXZpZGVyLmJnfTtcbiAgaGVpZ2h0OiAxMHB4O1xuICB3aWR0aDogMXB4O1xuICBtYXJnaW4tcmlnaHQ6ICR7KHsgd2lkdGggfSkgPT4gd2lkdGggLyA0fXB4O1xuYDtcclxuZXhwb3J0IGNvbnN0IFRpbWVsaW5lV3JhcHBlciA9IHN0eWxlZC5kaXYgYFxuICBwb3NpdGlvbjogc3RpY2t5O1xuICB0b3A6IDA7XG4gIGxlZnQ6ICR7KHsgaXNTaWRlYmFyLCBzaWRlYmFyV2lkdGggfSkgPT4gKGlzU2lkZWJhciA/IHNpZGViYXJXaWR0aCA6IDApfXB4O1xuICB6LWluZGV4OiAxMDtcbiAgZGlzcGxheTogZmxleDtcbiAgaGVpZ2h0OiAke0lURU1fSEVJR0hUIC0gMjB9cHg7XG4gIHdpZHRoOiAkeyh7IGRheVdpZHRoIH0pID0+IGRheVdpZHRofXB4O1xuICBiYWNrZ3JvdW5kOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnByaW1hcnlbOTAwXX07XG5gO1xyXG5leHBvcnQgY29uc3QgVGltZWxpbmVCb3ggPSBzdHlsZWQuZGl2IGBcbiAgd2lkdGg6ICR7KHsgd2lkdGggfSkgPT4gd2lkdGh9cHg7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gICY6Zmlyc3Qtb2YtdHlwZSB7XG4gICAgJHtUaW1lbGluZVRpbWV9IHtcbiAgICAgIGxlZnQ6IDBweDtcbiAgICB9XG4gIH1cbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVRpbWVsaW5lLnN0eWxlcy5qcy5tYXAiXX0= */"));
var TimelineDividers = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ebfc5083"
} : {
  target: "ebfc5083",
  label: "TimelineDividers"
})(process.env.NODE_ENV === "production" ? {
  name: "16adccg",
  styles: "height:100%;width:100%;display:grid;grid-template-columns:repeat(4, 1fr);align-items:end;padding-bottom:6px"
} : {
  name: "16adccg",
  styles: "height:100%;width:100%;display:grid;grid-template-columns:repeat(4, 1fr);align-items:end;padding-bottom:6px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRpbWVsaW5lLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXMkMiLCJmaWxlIjoiVGltZWxpbmUuc3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkL21hY3JvXCI7XHJcbi8vIEltcG9ydCBoZWxlcHJzXHJcbmltcG9ydCB7IElURU1fSEVJR0hUIH0gZnJvbSBcIi4uL2hlbHBlcnNcIjtcclxuZXhwb3J0IGNvbnN0IFRpbWVsaW5lVGltZSA9IHN0eWxlZC5zcGFuIGBcbiAgY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudGV4dC5ncmV5WzMwMF19O1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMThweDtcbiAgbGVmdDogJHsoeyBpc1JUTCwgaXNCYXNlVGltZUZvcm1hdCB9KSA9PiBpc1JUTCAmJiBpc0Jhc2VUaW1lRm9ybWF0ID8gXCItMzJcIiA6IFwiLTE4XCJ9cHg7XG5cbiAgJHsoeyBpc1JUTCB9KSA9PiBpc1JUTCAmJiBgdHJhbnNmb3JtOiBzY2FsZSgtMSwxKWB9O1xuYDtcclxuZXhwb3J0IGNvbnN0IFRpbWVsaW5lRGl2aWRlcnMgPSBzdHlsZWQuZGl2IGBcbiAgaGVpZ2h0OiAxMDAlO1xuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiByZXBlYXQoNCwgMWZyKTtcbiAgYWxpZ24taXRlbXM6IGVuZDtcbiAgcGFkZGluZy1ib3R0b206IDZweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZURpdmlkZXIgPSBzdHlsZWQuZGl2IGBcbiAgYmFja2dyb3VuZDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS50aW1lbGluZS5kaXZpZGVyLmJnfTtcbiAgaGVpZ2h0OiAxMHB4O1xuICB3aWR0aDogMXB4O1xuICBtYXJnaW4tcmlnaHQ6ICR7KHsgd2lkdGggfSkgPT4gd2lkdGggLyA0fXB4O1xuYDtcclxuZXhwb3J0IGNvbnN0IFRpbWVsaW5lV3JhcHBlciA9IHN0eWxlZC5kaXYgYFxuICBwb3NpdGlvbjogc3RpY2t5O1xuICB0b3A6IDA7XG4gIGxlZnQ6ICR7KHsgaXNTaWRlYmFyLCBzaWRlYmFyV2lkdGggfSkgPT4gKGlzU2lkZWJhciA/IHNpZGViYXJXaWR0aCA6IDApfXB4O1xuICB6LWluZGV4OiAxMDtcbiAgZGlzcGxheTogZmxleDtcbiAgaGVpZ2h0OiAke0lURU1fSEVJR0hUIC0gMjB9cHg7XG4gIHdpZHRoOiAkeyh7IGRheVdpZHRoIH0pID0+IGRheVdpZHRofXB4O1xuICBiYWNrZ3JvdW5kOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnByaW1hcnlbOTAwXX07XG5gO1xyXG5leHBvcnQgY29uc3QgVGltZWxpbmVCb3ggPSBzdHlsZWQuZGl2IGBcbiAgd2lkdGg6ICR7KHsgd2lkdGggfSkgPT4gd2lkdGh9cHg7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gICY6Zmlyc3Qtb2YtdHlwZSB7XG4gICAgJHtUaW1lbGluZVRpbWV9IHtcbiAgICAgIGxlZnQ6IDBweDtcbiAgICB9XG4gIH1cbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVRpbWVsaW5lLnN0eWxlcy5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
var TimelineDivider = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ebfc5082"
} : {
  target: "ebfc5082",
  label: "TimelineDivider"
})("background:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.timeline.divider.bg;
}, ";height:10px;width:1px;margin-right:", function (_ref5) {
  var width = _ref5.width;
  return width / 4;
}, "px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRpbWVsaW5lLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFtQjBDIiwiZmlsZSI6IlRpbWVsaW5lLnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZC9tYWNyb1wiO1xyXG4vLyBJbXBvcnQgaGVsZXByc1xyXG5pbXBvcnQgeyBJVEVNX0hFSUdIVCB9IGZyb20gXCIuLi9oZWxwZXJzXCI7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZVRpbWUgPSBzdHlsZWQuc3BhbiBgXG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnRleHQuZ3JleVszMDBdfTtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDE4cHg7XG4gIGxlZnQ6ICR7KHsgaXNSVEwsIGlzQmFzZVRpbWVGb3JtYXQgfSkgPT4gaXNSVEwgJiYgaXNCYXNlVGltZUZvcm1hdCA/IFwiLTMyXCIgOiBcIi0xOFwifXB4O1xuXG4gICR7KHsgaXNSVEwgfSkgPT4gaXNSVEwgJiYgYHRyYW5zZm9ybTogc2NhbGUoLTEsMSlgfTtcbmA7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZURpdmlkZXJzID0gc3R5bGVkLmRpdiBgXG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogcmVwZWF0KDQsIDFmcik7XG4gIGFsaWduLWl0ZW1zOiBlbmQ7XG4gIHBhZGRpbmctYm90dG9tOiA2cHg7XG5gO1xyXG5leHBvcnQgY29uc3QgVGltZWxpbmVEaXZpZGVyID0gc3R5bGVkLmRpdiBgXG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudGltZWxpbmUuZGl2aWRlci5iZ307XG4gIGhlaWdodDogMTBweDtcbiAgd2lkdGg6IDFweDtcbiAgbWFyZ2luLXJpZ2h0OiAkeyh7IHdpZHRoIH0pID0+IHdpZHRoIC8gNH1weDtcbmA7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZVdyYXBwZXIgPSBzdHlsZWQuZGl2IGBcbiAgcG9zaXRpb246IHN0aWNreTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAkeyh7IGlzU2lkZWJhciwgc2lkZWJhcldpZHRoIH0pID0+IChpc1NpZGViYXIgPyBzaWRlYmFyV2lkdGggOiAwKX1weDtcbiAgei1pbmRleDogMTA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGhlaWdodDogJHtJVEVNX0hFSUdIVCAtIDIwfXB4O1xuICB3aWR0aDogJHsoeyBkYXlXaWR0aCB9KSA9PiBkYXlXaWR0aH1weDtcbiAgYmFja2dyb3VuZDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5wcmltYXJ5WzkwMF19O1xuYDtcclxuZXhwb3J0IGNvbnN0IFRpbWVsaW5lQm94ID0gc3R5bGVkLmRpdiBgXG4gIHdpZHRoOiAkeyh7IHdpZHRoIH0pID0+IHdpZHRofXB4O1xuICBmb250LXNpemU6IDE0cHg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcblxuICAmOmZpcnN0LW9mLXR5cGUge1xuICAgICR7VGltZWxpbmVUaW1lfSB7XG4gICAgICBsZWZ0OiAwcHg7XG4gICAgfVxuICB9XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1UaW1lbGluZS5zdHlsZXMuanMubWFwIl19 */"));
var TimelineWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ebfc5081"
} : {
  target: "ebfc5081",
  label: "TimelineWrapper"
})("position:sticky;top:0;left:", function (_ref6) {
  var isSidebar = _ref6.isSidebar,
      sidebarWidth = _ref6.sidebarWidth;
  return isSidebar ? sidebarWidth : 0;
}, "px;z-index:10;display:flex;height:", ITEM_HEIGHT - 20, "px;width:", function (_ref7) {
  var dayWidth = _ref7.dayWidth;
  return dayWidth;
}, "px;background:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.primary[900];
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRpbWVsaW5lLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5QjBDIiwiZmlsZSI6IlRpbWVsaW5lLnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZC9tYWNyb1wiO1xyXG4vLyBJbXBvcnQgaGVsZXByc1xyXG5pbXBvcnQgeyBJVEVNX0hFSUdIVCB9IGZyb20gXCIuLi9oZWxwZXJzXCI7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZVRpbWUgPSBzdHlsZWQuc3BhbiBgXG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnRleHQuZ3JleVszMDBdfTtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDE4cHg7XG4gIGxlZnQ6ICR7KHsgaXNSVEwsIGlzQmFzZVRpbWVGb3JtYXQgfSkgPT4gaXNSVEwgJiYgaXNCYXNlVGltZUZvcm1hdCA/IFwiLTMyXCIgOiBcIi0xOFwifXB4O1xuXG4gICR7KHsgaXNSVEwgfSkgPT4gaXNSVEwgJiYgYHRyYW5zZm9ybTogc2NhbGUoLTEsMSlgfTtcbmA7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZURpdmlkZXJzID0gc3R5bGVkLmRpdiBgXG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogcmVwZWF0KDQsIDFmcik7XG4gIGFsaWduLWl0ZW1zOiBlbmQ7XG4gIHBhZGRpbmctYm90dG9tOiA2cHg7XG5gO1xyXG5leHBvcnQgY29uc3QgVGltZWxpbmVEaXZpZGVyID0gc3R5bGVkLmRpdiBgXG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudGltZWxpbmUuZGl2aWRlci5iZ307XG4gIGhlaWdodDogMTBweDtcbiAgd2lkdGg6IDFweDtcbiAgbWFyZ2luLXJpZ2h0OiAkeyh7IHdpZHRoIH0pID0+IHdpZHRoIC8gNH1weDtcbmA7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZVdyYXBwZXIgPSBzdHlsZWQuZGl2IGBcbiAgcG9zaXRpb246IHN0aWNreTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAkeyh7IGlzU2lkZWJhciwgc2lkZWJhcldpZHRoIH0pID0+IChpc1NpZGViYXIgPyBzaWRlYmFyV2lkdGggOiAwKX1weDtcbiAgei1pbmRleDogMTA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGhlaWdodDogJHtJVEVNX0hFSUdIVCAtIDIwfXB4O1xuICB3aWR0aDogJHsoeyBkYXlXaWR0aCB9KSA9PiBkYXlXaWR0aH1weDtcbiAgYmFja2dyb3VuZDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5wcmltYXJ5WzkwMF19O1xuYDtcclxuZXhwb3J0IGNvbnN0IFRpbWVsaW5lQm94ID0gc3R5bGVkLmRpdiBgXG4gIHdpZHRoOiAkeyh7IHdpZHRoIH0pID0+IHdpZHRofXB4O1xuICBmb250LXNpemU6IDE0cHg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcblxuICAmOmZpcnN0LW9mLXR5cGUge1xuICAgICR7VGltZWxpbmVUaW1lfSB7XG4gICAgICBsZWZ0OiAwcHg7XG4gICAgfVxuICB9XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1UaW1lbGluZS5zdHlsZXMuanMubWFwIl19 */"));
var TimelineBox = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ebfc5080"
} : {
  target: "ebfc5080",
  label: "TimelineBox"
})("width:", function (_ref9) {
  var width = _ref9.width;
  return width;
}, "px;font-size:14px;position:relative;&:first-of-type{", TimelineTime, "{left:0px;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRpbWVsaW5lLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFtQ3NDIiwiZmlsZSI6IlRpbWVsaW5lLnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZC9tYWNyb1wiO1xyXG4vLyBJbXBvcnQgaGVsZXByc1xyXG5pbXBvcnQgeyBJVEVNX0hFSUdIVCB9IGZyb20gXCIuLi9oZWxwZXJzXCI7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZVRpbWUgPSBzdHlsZWQuc3BhbiBgXG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnRleHQuZ3JleVszMDBdfTtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDE4cHg7XG4gIGxlZnQ6ICR7KHsgaXNSVEwsIGlzQmFzZVRpbWVGb3JtYXQgfSkgPT4gaXNSVEwgJiYgaXNCYXNlVGltZUZvcm1hdCA/IFwiLTMyXCIgOiBcIi0xOFwifXB4O1xuXG4gICR7KHsgaXNSVEwgfSkgPT4gaXNSVEwgJiYgYHRyYW5zZm9ybTogc2NhbGUoLTEsMSlgfTtcbmA7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZURpdmlkZXJzID0gc3R5bGVkLmRpdiBgXG4gIGhlaWdodDogMTAwJTtcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGdyaWQ7XG4gIGdyaWQtdGVtcGxhdGUtY29sdW1uczogcmVwZWF0KDQsIDFmcik7XG4gIGFsaWduLWl0ZW1zOiBlbmQ7XG4gIHBhZGRpbmctYm90dG9tOiA2cHg7XG5gO1xyXG5leHBvcnQgY29uc3QgVGltZWxpbmVEaXZpZGVyID0gc3R5bGVkLmRpdiBgXG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudGltZWxpbmUuZGl2aWRlci5iZ307XG4gIGhlaWdodDogMTBweDtcbiAgd2lkdGg6IDFweDtcbiAgbWFyZ2luLXJpZ2h0OiAkeyh7IHdpZHRoIH0pID0+IHdpZHRoIC8gNH1weDtcbmA7XHJcbmV4cG9ydCBjb25zdCBUaW1lbGluZVdyYXBwZXIgPSBzdHlsZWQuZGl2IGBcbiAgcG9zaXRpb246IHN0aWNreTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAkeyh7IGlzU2lkZWJhciwgc2lkZWJhcldpZHRoIH0pID0+IChpc1NpZGViYXIgPyBzaWRlYmFyV2lkdGggOiAwKX1weDtcbiAgei1pbmRleDogMTA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGhlaWdodDogJHtJVEVNX0hFSUdIVCAtIDIwfXB4O1xuICB3aWR0aDogJHsoeyBkYXlXaWR0aCB9KSA9PiBkYXlXaWR0aH1weDtcbiAgYmFja2dyb3VuZDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5wcmltYXJ5WzkwMF19O1xuYDtcclxuZXhwb3J0IGNvbnN0IFRpbWVsaW5lQm94ID0gc3R5bGVkLmRpdiBgXG4gIHdpZHRoOiAkeyh7IHdpZHRoIH0pID0+IHdpZHRofXB4O1xuICBmb250LXNpemU6IDE0cHg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcblxuICAmOmZpcnN0LW9mLXR5cGUge1xuICAgICR7VGltZWxpbmVUaW1lfSB7XG4gICAgICBsZWZ0OiAwcHg7XG4gICAgfVxuICB9XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1UaW1lbGluZS5zdHlsZXMuanMubWFwIl19 */"));

var Box$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ec9jzma0"
} : {
  target: "ec9jzma0",
  label: "Box"
})("position:absolute;top:64px;left:", function (_ref) {
  var left = _ref.left;
  return left;
}, "px;height:", function (_ref2) {
  var height = _ref2.height;
  return height;
}, "px;width:3px;background:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.green[300];
}, ";pointer-events:none;z-index:10;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpbmUuc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUM4QiIsImZpbGUiOiJMaW5lLnN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZC9tYWNyb1wiO1xyXG5leHBvcnQgY29uc3QgQm94ID0gc3R5bGVkLmRpdiBgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA2NHB4O1xuICBsZWZ0OiAkeyh7IGxlZnQgfSkgPT4gbGVmdH1weDtcbiAgaGVpZ2h0OiAkeyh7IGhlaWdodCB9KSA9PiBoZWlnaHR9cHg7XG4gIHdpZHRoOiAzcHg7XG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuZ3JlZW5bMzAwXX07XG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICB6LWluZGV4OiAxMDtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUxpbmUuc3R5bGVzLmpzLm1hcCJdfQ== */"));

var _templateObject$1;
var time = [0, 50, 0];

var moveLeft = function moveLeft(animate) {
  return keyframes(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n", "\n"])), time.map(function (item, index) {
    return item + "% {\n  transform: translateX(-" + animate.right[index] + ");\n}";
  }));
};

var Box$3 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ezp5axu1"
} : {
  target: "ezp5axu1",
  label: "Box"
})("position:absolute;top:0;left:0;bottom:0;width:100%;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.loader.bg;
}, ";display:flex;justify-content:center;align-items:center;z-index:100;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvYWRlci5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUThCIiwiZmlsZSI6IkxvYWRlci5zdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gXCJAZW1vdGlvbi9zdHlsZWQvbWFjcm9cIjtcclxuaW1wb3J0IHsga2V5ZnJhbWVzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCI7XHJcbmNvbnN0IHRpbWUgPSBbMCwgNTAsIDBdO1xyXG5jb25zdCBtb3ZlTGVmdCA9IChhbmltYXRlKSA9PiBrZXlmcmFtZXMgYFxuJHt0aW1lLm1hcCgoaXRlbSwgaW5kZXgpID0+IGAke2l0ZW19JSB7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgtJHthbmltYXRlLnJpZ2h0W2luZGV4XX0pO1xufWApfVxuYDtcclxuZXhwb3J0IGNvbnN0IEJveCA9IHN0eWxlZC5kaXYgYFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgYm90dG9tOiAwO1xuICB3aWR0aDogMTAwJTtcbiAgYmFja2dyb3VuZDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5sb2FkZXIuYmd9O1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgei1pbmRleDogMTAwO1xuYDtcclxuZXhwb3J0IGNvbnN0IFNoYXBlID0gc3R5bGVkLmRpdiBgXG4gIHdpZHRoOiAkeyh7IHdpZHRoIH0pID0+IHdpZHRoICogMC40Mn1weDtcbiAgYmFja2dyb3VuZDogJHsoeyBjb2xvciB9KSA9PiBjb2xvcn07XG4gIGhlaWdodDogMThweDtcbiAgYm9yZGVyLXJhZGl1czogNDVweDtcbiAgbWFyZ2luLXJpZ2h0OiAkeyh7IG1hcmdpblJpZ2h0IH0pID0+IG1hcmdpblJpZ2h0ID8/IDB9cHg7XG4gIGFuaW1hdGlvbi1uYW1lOiAkeyh7IGFuaW1hdGUgfSkgPT4gbW92ZUxlZnQoYW5pbWF0ZSl9O1xuICBhbmltYXRpb24tZHVyYXRpb246ICR7KHsgdHJhbnNpdGlvbiB9KSA9PiB0cmFuc2l0aW9uLmR1cmF0aW9ufXM7XG4gIGFuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246ICR7KHsgdHJhbnNpdGlvbiB9KSA9PiB0cmFuc2l0aW9uLmVhc2UgPz8gXCJlYXNlLWluLW91dFwifTtcbiAgYW5pbWF0aW9uLWRlbGF5OiAkeyh7IHRyYW5zaXRpb24gfSkgPT4gdHJhbnNpdGlvbi5kZWxheSA/PyAwfXM7XG4gIGFuaW1hdGlvbi1pdGVyYXRpb24tY291bnQ6IGluZmluaXRlO1xuYDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9TG9hZGVyLnN0eWxlcy5qcy5tYXAiXX0= */"));
var Shape = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ezp5axu0"
} : {
  target: "ezp5axu0",
  label: "Shape"
})("width:", function (_ref2) {
  var width = _ref2.width;
  return width * 0.42;
}, "px;background:", function (_ref3) {
  var color = _ref3.color;
  return color;
}, ";height:18px;border-radius:45px;margin-right:", function (_ref4) {
  var marginRight = _ref4.marginRight;
  return marginRight != null ? marginRight : 0;
}, "px;animation-name:", function (_ref5) {
  var animate = _ref5.animate;
  return moveLeft(animate);
}, ";animation-duration:", function (_ref6) {
  var transition = _ref6.transition;
  return transition.duration;
}, "s;animation-timing-function:", function (_ref7) {
  var _transition$ease;

  var transition = _ref7.transition;
  return (_transition$ease = transition.ease) != null ? _transition$ease : "ease-in-out";
}, ";animation-delay:", function (_ref8) {
  var _transition$delay;

  var transition = _ref8.transition;
  return (_transition$delay = transition.delay) != null ? _transition$delay : 0;
}, "s;animation-iteration-count:infinite;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvYWRlci5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0JnQyIsImZpbGUiOiJMb2FkZXIuc3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkL21hY3JvXCI7XHJcbmltcG9ydCB7IGtleWZyYW1lcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xyXG5jb25zdCB0aW1lID0gWzAsIDUwLCAwXTtcclxuY29uc3QgbW92ZUxlZnQgPSAoYW5pbWF0ZSkgPT4ga2V5ZnJhbWVzIGBcbiR7dGltZS5tYXAoKGl0ZW0sIGluZGV4KSA9PiBgJHtpdGVtfSUge1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLSR7YW5pbWF0ZS5yaWdodFtpbmRleF19KTtcbn1gKX1cbmA7XHJcbmV4cG9ydCBjb25zdCBCb3ggPSBzdHlsZWQuZGl2IGBcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDA7XG4gIGxlZnQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgd2lkdGg6IDEwMCU7XG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUubG9hZGVyLmJnfTtcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHotaW5kZXg6IDEwMDtcbmA7XHJcbmV4cG9ydCBjb25zdCBTaGFwZSA9IHN0eWxlZC5kaXYgYFxuICB3aWR0aDogJHsoeyB3aWR0aCB9KSA9PiB3aWR0aCAqIDAuNDJ9cHg7XG4gIGJhY2tncm91bmQ6ICR7KHsgY29sb3IgfSkgPT4gY29sb3J9O1xuICBoZWlnaHQ6IDE4cHg7XG4gIGJvcmRlci1yYWRpdXM6IDQ1cHg7XG4gIG1hcmdpbi1yaWdodDogJHsoeyBtYXJnaW5SaWdodCB9KSA9PiBtYXJnaW5SaWdodCA/PyAwfXB4O1xuICBhbmltYXRpb24tbmFtZTogJHsoeyBhbmltYXRlIH0pID0+IG1vdmVMZWZ0KGFuaW1hdGUpfTtcbiAgYW5pbWF0aW9uLWR1cmF0aW9uOiAkeyh7IHRyYW5zaXRpb24gfSkgPT4gdHJhbnNpdGlvbi5kdXJhdGlvbn1zO1xuICBhbmltYXRpb24tdGltaW5nLWZ1bmN0aW9uOiAkeyh7IHRyYW5zaXRpb24gfSkgPT4gdHJhbnNpdGlvbi5lYXNlID8/IFwiZWFzZS1pbi1vdXRcIn07XG4gIGFuaW1hdGlvbi1kZWxheTogJHsoeyB0cmFuc2l0aW9uIH0pID0+IHRyYW5zaXRpb24uZGVsYXkgPz8gMH1zO1xuICBhbmltYXRpb24taXRlcmF0aW9uLWNvdW50OiBpbmZpbml0ZTtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUxvYWRlci5zdHlsZXMuanMubWFwIl19 */"));

var ScrollBox$1 = ScrollBox,
    Content$1 = Content;
var Layout = /*#__PURE__*/React__default.forwardRef(function (props, scrollBoxRef) {
  var channels = props.channels,
      programs = props.programs,
      startDate = props.startDate,
      endDate = props.endDate,
      scrollY = props.scrollY;
  var dayWidth = props.dayWidth,
      hourWidth = props.hourWidth,
      sidebarWidth = props.sidebarWidth,
      itemHeight = props.itemHeight;
  var numberOfHoursInDay = props.numberOfHoursInDay,
      offsetStartHoursRange = props.offsetStartHoursRange;
  var _props$isSidebar = props.isSidebar,
      isSidebar = _props$isSidebar === void 0 ? true : _props$isSidebar,
      _props$isTimeline = props.isTimeline,
      isTimeline = _props$isTimeline === void 0 ? true : _props$isTimeline,
      _props$isLine = props.isLine,
      isLine = _props$isLine === void 0 ? true : _props$isLine,
      _props$isBaseTimeForm = props.isBaseTimeFormat,
      isBaseTimeFormat = _props$isBaseTimeForm === void 0 ? false : _props$isBaseTimeForm,
      _props$isRTL = props.isRTL,
      isRTL = _props$isRTL === void 0 ? false : _props$isRTL;
  var onScroll = props.onScroll,
      isProgramVisible = props.isProgramVisible,
      isChannelVisible = props.isChannelVisible,
      renderProgram = props.renderProgram,
      renderChannel = props.renderChannel,
      renderTimeline = props.renderTimeline;
  var channelsLength = channels.length;
  var contentHeight = React__default.useMemo(function () {
    return channelsLength * itemHeight;
  }, [channelsLength, itemHeight]);
  var isFuture = isFutureTime(endDate);

  var renderPrograms = function renderPrograms(program) {
    var position = program.position;
    var isVisible = isProgramVisible(position);

    if (isVisible) {
      var options = getProgramOptions(program);
      if (renderProgram) return renderProgram({
        program: options,
        isRTL: isRTL,
        isBaseTimeFormat: isBaseTimeFormat
      });
      return React__default.createElement(Program, {
        key: program.data.id,
        isRTL: isRTL,
        isBaseTimeFormat: isBaseTimeFormat,
        program: options
      });
    }

    return null;
  };

  var renderTopbar = function renderTopbar() {
    var props = {
      sidebarWidth: sidebarWidth,
      isSidebar: isSidebar,
      isRTL: isRTL,
      dayWidth: dayWidth,
      numberOfHoursInDay: numberOfHoursInDay
    };
    var timeProps = {
      offsetStartHoursRange: offsetStartHoursRange,
      numberOfHoursInDay: numberOfHoursInDay,
      isBaseTimeFormat: isBaseTimeFormat,
      hourWidth: hourWidth
    };

    if (renderTimeline) {
      return renderTimeline(_extends({}, timeProps, props));
    }

    return React__default.createElement(Timeline, Object.assign({}, timeProps, props));
  };

  return React__default.createElement(ScrollBox$1, {
    isRTL: isRTL,
    ref: scrollBoxRef,
    onScroll: onScroll
  }, isLine && isFuture && React__default.createElement(Line, {
    dayWidth: dayWidth,
    hourWidth: hourWidth,
    sidebarWidth: sidebarWidth,
    startDate: startDate,
    endDate: endDate,
    height: contentHeight
  }), isTimeline && renderTopbar(), isSidebar && React__default.createElement(Channels, {
    isRTL: isRTL,
    isTimeline: isTimeline,
    isChannelVisible: isChannelVisible,
    sidebarWidth: sidebarWidth,
    channels: channels,
    scrollY: scrollY,
    renderChannel: renderChannel
  }), React__default.createElement(Content$1, {
    "data-testid": "content",
    sidebarWidth: sidebarWidth,
    isSidebar: isSidebar,
    width: dayWidth,
    height: contentHeight
  }, programs.map(function (program) {
    return renderPrograms(program);
  })));
});

var theme = {
  primary: {
    600: "#1a202c",
    900: "#171923"
  },
  grey: {
    300: "#d1d1d1"
  },
  white: "#fff",
  green: {
    300: "#2C7A7B"
  },
  loader: {
    teal: "#5DDADB",
    purple: "#3437A2",
    pink: "#F78EB6",
    bg: "#171923db"
  },
  scrollbar: {
    border: "#ffffff",
    thumb: {
      bg: "#e1e1e1"
    }
  },
  gradient: {
    blue: {
      300: "#002eb3",
      600: "#002360",
      900: "#051937"
    }
  },
  text: {
    grey: {
      300: "#a0aec0",
      500: "#718096"
    }
  },
  timeline: {
    divider: {
      bg: "#718096"
    }
  }
};

function useLayout(_ref) {
  var height = _ref.height,
      width = _ref.width,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      hourWidth = _ref.hourWidth,
      sidebarWidth = _ref.sidebarWidth;
  var useIsomorphicEffect = useIsomorphicLayoutEffect();
  var containerRef = React__default.useRef(null);
  var scrollBoxRef = React__default.useRef(null); //-------- State --------

  var _React$useState = React__default.useState(0),
      scrollY = _React$useState[0],
      setScrollY = _React$useState[1];

  var _React$useState2 = React__default.useState(0),
      scrollX = _React$useState2[0],
      setScrollX = _React$useState2[1];

  var _React$useState3 = React__default.useState(width),
      layoutWidth = _React$useState3[0],
      setLayoutWidth = _React$useState3[1];

  var _React$useState4 = React__default.useState(height),
      layoutHeight = _React$useState4[0],
      setLayoutHeight = _React$useState4[1];

  var isToday$1 = isToday(new Date(startDate)); // -------- Handlers --------

  var handleScrollDebounced = useDebouncedCallback(function (value) {
    setScrollY(value.y);
    setScrollX(value.x);
  }, DEBOUNCE_WAIT, {
    maxWait: DEBOUNCE_WAIT_MAX
  });
  var handleOnScroll = React__default.useCallback(function (e) {
    handleScrollDebounced({
      y: e.target.scrollTop,
      x: e.target.scrollLeft
    });
  }, [handleScrollDebounced]);
  var handleOnScrollToNow = React__default.useCallback(function () {
    if (scrollBoxRef != null && scrollBoxRef.current && isToday$1) {
      var _containerRef$current;

      var clientWidth = width != null ? width : (_containerRef$current = containerRef.current) == null ? void 0 : _containerRef$current.clientWidth;
      var newDate = new Date();
      var scrollPosition = getPositionX(startOfToday(), newDate, startDate, endDate, hourWidth);
      var scrollNow = scrollPosition - clientWidth / 2 + sidebarWidth;
      scrollBoxRef.current.scrollLeft = scrollNow;
    }
  }, [isToday$1, startDate, endDate, width, sidebarWidth, hourWidth]);
  var handleOnScrollTop = React__default.useCallback(function (value) {
    if (value === void 0) {
      value = hourWidth;
    }

    if (scrollBoxRef != null && scrollBoxRef.current) {
      var top = scrollBoxRef.current.scrollTop + value;
      scrollBoxRef.current.scrollTop = top;
    }
  }, [hourWidth]);
  var handleOnScrollRight = React__default.useCallback(function (value) {
    if (value === void 0) {
      value = hourWidth;
    }

    if (scrollBoxRef != null && scrollBoxRef.current) {
      var right = scrollBoxRef.current.scrollLeft + value;
      scrollBoxRef.current.scrollLeft = right;
    }
  }, [hourWidth]);
  var handleOnScrollLeft = React__default.useCallback(function (value) {
    if (value === void 0) {
      value = hourWidth;
    }

    if (scrollBoxRef != null && scrollBoxRef.current) {
      var left = scrollBoxRef.current.scrollLeft - value;
      scrollBoxRef.current.scrollLeft = left;
    }
  }, [hourWidth]);
  var handleResizeDebounced = useDebouncedCallback(function () {
    if (containerRef != null && containerRef.current && !width) {
      var container = containerRef.current;
      var clientWidth = container.clientWidth;
      setLayoutWidth(clientWidth);
    }
  }, DEBOUNCE_WAIT * 4, {
    maxWait: DEBOUNCE_WAIT_MAX * 4
  }); // -------- Efffects --------

  useIsomorphicEffect(function () {
    if (containerRef != null && containerRef.current) {
      var container = containerRef.current;

      if (!width) {
        var clientWidth = container.clientWidth;
        setLayoutWidth(clientWidth);
      }

      if (!height) {
        var clientHeight = container.clientHeight;
        setLayoutHeight(clientHeight);
      }
    }

    if (scrollBoxRef != null && scrollBoxRef.current && isToday$1) {
      handleOnScrollToNow();
    }
  }, [height, width, startDate, isToday$1, handleOnScrollToNow]);
  useIsomorphicEffect(function () {
    window.addEventListener("resize", handleResizeDebounced);
    return function () {
      window.removeEventListener("resize", handleResizeDebounced);
    };
  }, [width]);
  return {
    containerRef: containerRef,
    scrollBoxRef: scrollBoxRef,
    scrollX: scrollX,
    scrollY: scrollY,
    layoutWidth: layoutWidth,
    layoutHeight: layoutHeight,
    onScroll: handleOnScroll,
    onScrollToNow: handleOnScrollToNow,
    onScrollTop: handleOnScrollTop,
    onScrollLeft: handleOnScrollLeft,
    onScrollRight: handleOnScrollRight
  };
}

var _excluded = ["hourWidth", "dayWidth"],
    _excluded2 = ["containerRef", "scrollBoxRef"];
var defaultStartDateTime = /*#__PURE__*/formatTime( /*#__PURE__*/startOfToday());
function useEpg(_ref) {
  var channelsEpg = _ref.channels,
      epg = _ref.epg,
      _ref$startDate = _ref.startDate,
      startDateInput = _ref$startDate === void 0 ? defaultStartDateTime : _ref$startDate,
      _ref$endDate = _ref.endDate,
      endDateInput = _ref$endDate === void 0 ? "" : _ref$endDate,
      _ref$isRTL = _ref.isRTL,
      isRTL = _ref$isRTL === void 0 ? false : _ref$isRTL,
      _ref$isBaseTimeFormat = _ref.isBaseTimeFormat,
      isBaseTimeFormat = _ref$isBaseTimeFormat === void 0 ? false : _ref$isBaseTimeFormat,
      _ref$isSidebar = _ref.isSidebar,
      isSidebar = _ref$isSidebar === void 0 ? true : _ref$isSidebar,
      _ref$isTimeline = _ref.isTimeline,
      isTimeline = _ref$isTimeline === void 0 ? true : _ref$isTimeline,
      _ref$isLine = _ref.isLine,
      isLine = _ref$isLine === void 0 ? true : _ref$isLine,
      customTheme = _ref.theme,
      globalStyles = _ref.globalStyles,
      _ref$dayWidth = _ref.dayWidth,
      customDayWidth = _ref$dayWidth === void 0 ? DAY_WIDTH : _ref$dayWidth,
      _ref$sidebarWidth = _ref.sidebarWidth,
      sidebarWidth = _ref$sidebarWidth === void 0 ? SIDEBAR_WIDTH : _ref$sidebarWidth,
      _ref$itemHeight = _ref.itemHeight,
      itemHeight = _ref$itemHeight === void 0 ? ITEM_HEIGHT : _ref$itemHeight,
      _ref$itemOverscan = _ref.itemOverscan,
      itemOverscan = _ref$itemOverscan === void 0 ? ITEM_OVERSCAN : _ref$itemOverscan,
      width = _ref.width,
      height = _ref.height;

  // Get converted start and end dates
  var _getTimeRangeDates = getTimeRangeDates(startDateInput, endDateInput),
      startDate = _getTimeRangeDates.startDate,
      endDate = _getTimeRangeDates.endDate; // Get day and hour width of the day


  var _React$useMemo = React__default.useMemo(function () {
    return getDayWidthResources({
      dayWidth: customDayWidth,
      startDate: startDate,
      endDate: endDate
    });
  }, [customDayWidth, startDate, endDate]),
      hourWidth = _React$useMemo.hourWidth,
      dayWidth = _React$useMemo.dayWidth,
      dayWidthResourcesProps = _objectWithoutPropertiesLoose(_React$useMemo, _excluded); // -------- Effects --------


  var _useLayout = useLayout({
    startDate: startDate,
    endDate: endDate,
    sidebarWidth: sidebarWidth,
    width: width,
    height: height,
    hourWidth: hourWidth
  }),
      containerRef = _useLayout.containerRef,
      scrollBoxRef = _useLayout.scrollBoxRef,
      layoutProps = _objectWithoutPropertiesLoose(_useLayout, _excluded2);

  var scrollX = layoutProps.scrollX,
      scrollY = layoutProps.scrollY,
      layoutWidth = layoutProps.layoutWidth,
      layoutHeight = layoutProps.layoutHeight;
  var onScroll = layoutProps.onScroll,
      onScrollToNow = layoutProps.onScrollToNow,
      onScrollTop = layoutProps.onScrollTop,
      onScrollLeft = layoutProps.onScrollLeft,
      onScrollRight = layoutProps.onScrollRight; //-------- Variables --------

  var channels = React__default.useMemo(function () {
    return getConvertedChannels(channelsEpg, itemHeight);
  }, [channelsEpg, itemHeight]);
  var startDateTime = formatTime(startDate);
  var endDateTime = formatTime(endDate);
  var programs = React__default.useMemo(function () {
    return getConvertedPrograms({
      data: epg,
      channels: channels,
      startDate: startDateTime,
      endDate: endDateTime,
      itemHeight: itemHeight,
      hourWidth: hourWidth
    });
  }, [epg, channels, startDateTime, endDateTime, itemHeight, hourWidth]);
  var theme$1 = customTheme || theme; // -------- Handlers --------

  var isProgramVisible = React__default.useCallback(function (position) {
    return getItemVisibility(position, scrollY, scrollX, layoutHeight, layoutWidth, itemOverscan);
  }, [scrollY, scrollX, layoutHeight, layoutWidth, itemOverscan]);
  var isChannelVisible = React__default.useCallback(function (position) {
    return getSidebarItemVisibility(position, scrollY, layoutHeight, itemOverscan);
  }, [scrollY, layoutHeight, itemOverscan]);

  var getEpgProps = function getEpgProps() {
    return {
      isRTL: isRTL,
      isSidebar: isSidebar,
      isLine: isLine,
      isTimeline: isTimeline,
      width: width,
      height: height,
      sidebarWidth: sidebarWidth,
      ref: containerRef,
      theme: theme$1,
      globalStyles: globalStyles
    };
  };

  var getLayoutProps = function getLayoutProps() {
    return _extends({
      programs: programs,
      channels: channels,
      startDate: startDate,
      endDate: endDate,
      scrollY: scrollY,
      onScroll: onScroll,
      isRTL: isRTL,
      isBaseTimeFormat: isBaseTimeFormat,
      isSidebar: isSidebar,
      isTimeline: isTimeline,
      isLine: isLine,
      isProgramVisible: isProgramVisible,
      isChannelVisible: isChannelVisible,
      dayWidth: dayWidth,
      hourWidth: hourWidth,
      sidebarWidth: sidebarWidth,
      itemHeight: itemHeight
    }, dayWidthResourcesProps, {
      ref: scrollBoxRef
    });
  };

  return {
    getEpgProps: getEpgProps,
    getLayoutProps: getLayoutProps,
    onScrollToNow: onScrollToNow,
    onScrollTop: onScrollTop,
    onScrollLeft: onScrollLeft,
    onScrollRight: onScrollRight,
    scrollY: scrollY,
    scrollX: scrollX
  };
}

function useInterval(callback, delay) {
  var useIsomorphicEffect = useIsomorphicLayoutEffect();
  var savedCallback = React__default.useRef(callback);
  useIsomorphicEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  React__default.useEffect(function () {
    if (!delay && delay !== 0) {
      return;
    }

    var id = setInterval(function () {
      return savedCallback.current();
    }, delay);
    return function () {
      return clearInterval(id);
    };
  }, [delay]);
}

function useProgram(_ref) {
  var _ref$isRTL = _ref.isRTL,
      isRTL = _ref$isRTL === void 0 ? false : _ref$isRTL,
      isBaseTimeFormat = _ref.isBaseTimeFormat,
      program = _ref.program,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 200 : _ref$minWidth;
  var data = program.data,
      position = program.position;
  var width = position.width;
  var since = data.since,
      till = data.till;

  var _React$useState = React__default.useState(function () {
    return getLiveStatus(since, till);
  }),
      isLive = _React$useState[0],
      setIsLive = _React$useState[1];

  var newPosition = omit(position, "egdeEnd");

  var formatTime = function formatTime(date, formatType) {
    if (formatType === void 0) {
      formatType = TIME_FORMAT.HOURS_MIN;
    }

    return format(new Date(date), formatType).replace(/\s/g, "");
  };

  var set12HoursTimeFormat = function set12HoursTimeFormat() {
    if (isBaseTimeFormat) return TIME_FORMAT.BASE_HOURS_TIME;
    return TIME_FORMAT.HOURS_MIN;
  };

  var getRTLSinceTime = function getRTLSinceTime(since) {
    return isRTL ? till : since;
  };

  var getRTLTillTime = function getRTLTillTime(till) {
    return isRTL ? since : till;
  };

  useInterval(function () {
    var status = getLiveStatus(since, till);
    setIsLive(status);
  }, PROGRAM_REFRESH);
  var isMinWidth = width > minWidth;
  return {
    isLive: isLive,
    isMinWidth: isMinWidth,
    isRTL: isRTL,
    formatTime: formatTime,
    set12HoursTimeFormat: set12HoursTimeFormat,
    getRTLSinceTime: getRTLSinceTime,
    getRTLTillTime: getRTLTillTime,
    styles: {
      width: width,
      position: newPosition
    }
  };
}

function useTimeline(numberOfHoursInDay, isBaseTimeFormat) {
  var time = generateArray(numberOfHoursInDay);
  var dividers = generateArray(4);

  var formatTime = function formatTime(index) {
    var date = new Date();
    var baseDate = format(date, TIME_FORMAT.DATE);
    var time = index < 10 ? "0" + index : index;

    if (isBaseTimeFormat) {
      var _date = new Date(baseDate + "T" + time + ":00:00");

      var timeFormat = format(_date, TIME_FORMAT.BASE_HOURS_TIME);
      return timeFormat.toLowerCase().replace(/\s/g, "");
    }

    return time + ":00";
  };

  return {
    time: time,
    dividers: dividers,
    formatTime: formatTime
  };
}

var _excluded$1 = ["program", "onClick"];
var ProgramBox$1 = ProgramBox,
    ProgramContent$1 = ProgramContent,
    ProgramFlex$1 = ProgramFlex,
    ProgramStack$1 = ProgramStack,
    ProgramTitle$1 = ProgramTitle,
    ProgramText$1 = ProgramText,
    ProgramImage$1 = ProgramImage;
function Program(_ref) {
  var program = _ref.program,
      onClick = _ref.onClick,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var _useProgram = useProgram(_extends({
    program: program
  }, rest)),
      isRTL = _useProgram.isRTL,
      isLive = _useProgram.isLive,
      isMinWidth = _useProgram.isMinWidth,
      styles = _useProgram.styles,
      formatTime = _useProgram.formatTime,
      set12HoursTimeFormat = _useProgram.set12HoursTimeFormat,
      getRTLSinceTime = _useProgram.getRTLSinceTime,
      getRTLTillTime = _useProgram.getRTLTillTime;

  var data = program.data;
  var image = data.image,
      title = data.title,
      since = data.since,
      till = data.till;

  var handleOnContentClick = function handleOnContentClick() {
    return onClick == null ? void 0 : onClick(data);
  };

  var sinceTime = formatTime(getRTLSinceTime(since), set12HoursTimeFormat()).toLowerCase();
  var tillTime = formatTime(getRTLTillTime(till), set12HoursTimeFormat()).toLowerCase();
  return createElement(ProgramBox$1, {
    "data-testid": "program-item",
    width: styles.width,
    style: styles.position
  }, createElement(ProgramContent$1, Object.assign({
    "data-testid": "program-content",
    width: styles.width,
    isLive: isLive,
    onClick: handleOnContentClick
  }, rest), createElement(ProgramFlex$1, null, isLive && isMinWidth && createElement(ProgramImage$1, {
    src: image,
    alt: "Preview"
  }), createElement(ProgramStack$1, {
    isRTL: isRTL
  }, createElement(ProgramTitle$1, null, title), createElement(ProgramText$1, {
    "aria-label": "program time"
  }, sinceTime, " - ", tillTime)))));
}

var Box$4 = Box$1;
function Channels(props) {
  var channels = props.channels,
      scrollY = props.scrollY,
      sidebarWidth = props.sidebarWidth,
      renderChannel = props.renderChannel;
  var isRTL = props.isRTL,
      isTimeline = props.isTimeline,
      isChannelVisible = props.isChannelVisible;

  var renderChannels = function renderChannels(channel) {
    var isVisible = isChannelVisible(channel.position);

    if (isVisible) {
      if (renderChannel) return renderChannel({
        channel: channel
      });
      return createElement(Channel, {
        key: channel.uuid,
        channel: channel
      });
    }

    return null;
  };

  return createElement(Box$4, {
    "data-testid": "sidebar",
    isRTL: isRTL,
    isTimeline: isTimeline,
    width: sidebarWidth,
    bottom: scrollY
  }, channels.map(renderChannels));
}

var _excluded$2 = ["channel", "onClick"];
var ChannelBox$1 = ChannelBox,
    ChannelLogo$1 = ChannelLogo;
function Channel(_ref) {
  var channel = _ref.channel,
      _onClick = _ref.onClick,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);

  var position = channel.position,
      logo = channel.logo;
  return createElement(ChannelBox$1, Object.assign({
    "data-testid": "sidebar-item",
    onClick: function onClick() {
      return _onClick == null ? void 0 : _onClick(channel);
    }
  }, position, rest), createElement(ChannelLogo$1, {
    src: logo,
    alt: "Logo"
  }));
}

var TimelineWrapper$1 = TimelineWrapper,
    TimelineBox$1 = TimelineBox,
    TimelineTime$1 = TimelineTime,
    TimelineDividers$1 = TimelineDividers,
    TimelineDivider$1 = TimelineDivider;
function Timeline(_ref) {
  var isRTL = _ref.isRTL,
      isBaseTimeFormat = _ref.isBaseTimeFormat,
      isSidebar = _ref.isSidebar,
      dayWidth = _ref.dayWidth,
      hourWidth = _ref.hourWidth,
      numberOfHoursInDay = _ref.numberOfHoursInDay,
      offsetStartHoursRange = _ref.offsetStartHoursRange,
      sidebarWidth = _ref.sidebarWidth;

  var _useTimeline = useTimeline(numberOfHoursInDay, isBaseTimeFormat),
      time = _useTimeline.time,
      dividers = _useTimeline.dividers,
      formatTime = _useTimeline.formatTime;

  var renderTime = function renderTime(index) {
    return createElement(TimelineBox$1, {
      "data-testid": "timeline-item",
      key: index,
      width: hourWidth
    }, createElement(TimelineTime$1, {
      isBaseTimeFormat: isBaseTimeFormat,
      isRTL: isRTL
    }, formatTime(index + offsetStartHoursRange)), createElement(TimelineDividers$1, null, renderDividers()));
  };

  var renderDividers = function renderDividers() {
    return dividers.map(function (_, index) {
      return createElement(TimelineDivider$1, {
        key: index,
        width: hourWidth
      });
    });
  };

  return createElement(TimelineWrapper$1, {
    "data-testid": "timeline",
    dayWidth: dayWidth,
    sidebarWidth: sidebarWidth,
    isSidebar: isSidebar
  }, time.map(function (_, index) {
    return renderTime(index);
  }));
}

function useLine(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate,
      dayWidth = _ref.dayWidth,
      hourWidth = _ref.hourWidth,
      sidebarWidth = _ref.sidebarWidth;
  var initialState = getPositionX(startOfDay(new Date(startDate)), new Date(), startDate, endDate, hourWidth) + sidebarWidth;

  var _React$useState = React__default.useState(function () {
    return initialState;
  }),
      positionX = _React$useState[0],
      setPositionX = _React$useState[1];

  var isDayEnd = positionX <= dayWidth;
  var isScrollX = React__default.useMemo(function () {
    return isDayEnd ? PROGRAM_REFRESH : null;
  }, [isDayEnd]);
  useInterval(function () {
    var offset = hourWidth / HOUR_IN_MINUTES;
    var positionOffset = offset * 2;
    setPositionX(function (prev) {
      return prev + positionOffset;
    });
  }, isScrollX);
  React__default.useEffect(function () {
    var date = new Date(startDate);
    var positionX = getPositionX(startOfDay(date), new Date(), startDate, endDate, hourWidth);
    var newPositionX = positionX + sidebarWidth;
    setPositionX(newPositionX);
  }, [startDate, endDate, sidebarWidth, hourWidth]);
  return {
    positionX: positionX
  };
}

var Box$5 = Box$2;
function Line(_ref) {
  var height = _ref.height,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      dayWidth = _ref.dayWidth,
      hourWidth = _ref.hourWidth,
      sidebarWidth = _ref.sidebarWidth;

  var _useLine = useLine({
    startDate: startDate,
    endDate: endDate,
    dayWidth: dayWidth,
    hourWidth: hourWidth,
    sidebarWidth: sidebarWidth
  }),
      positionX = _useLine.positionX;

  var date = new Date(startDate);
  if (!isToday(date)) return null;
  return createElement(Box$5, {
    height: height,
    left: positionX
  });
}

var Box$6 = Box$3,
    Shape$1 = Shape;

var Element = function Element(_ref) {
  var width = _ref.width,
      color = _ref.color,
      animate = _ref.animate,
      marginRight = _ref.marginRight,
      transition = _ref.transition;
  return createElement(Shape$1, {
    className: "SHAPE",
    width: width,
    color: color,
    animate: animate,
    transition: transition,
    marginRight: marginRight
  });
};

function Loader() {
  return createElement(Box$6, {
    "aria-label": "loading"
  }, createElement("div", null, createElement("div", {
    style: {
      display: "flex",
      justifyContent: "end",
      marginBottom: 16
    }
  }, createElement(Element, {
    animate: {
      right: ["0px", "75px", "0px"]
    },
    transition: {
      duration: 1
    },
    width: 217,
    color: theme.loader.teal,
    marginRight: 10
  }), createElement(Element, {
    width: 122,
    color: theme.loader.purple,
    animate: {
      right: ["0px", "50px", "0px"]
    },
    transition: {
      duration: 1,
      delay: 0.02
    }
  })), createElement("div", {
    style: {
      display: "flex",
      justifyContent: "end",
      marginBottom: 16
    }
  }, createElement(Element, {
    width: 267,
    color: theme.loader.pink,
    animate: {
      right: ["0px", "70px", "0px"]
    },
    transition: {
      delay: 0.5,
      duration: 1
    }
  })), createElement("div", {
    style: {
      display: "flex",
      justifyContent: "end"
    }
  }, createElement(Element, {
    width: 217,
    color: theme.loader.purple,
    marginRight: 10,
    animate: {
      right: ["0px", "95px", "0px"]
    },
    transition: {
      delay: 0.3,
      duration: 1
    }
  }), createElement(Element, {
    width: 80,
    color: theme.loader.teal,
    animate: {
      right: ["0px", "70px", "0px"]
    },
    transition: {
      duration: 1,
      delay: 0.33
    }
  }))));
}

var _excluded$3 = ["children", "width", "height", "sidebarWidth", "theme", "globalStyles", "isRTL", "isSidebar", "isTimeline", "isLoading", "loader"];
var Container$1 = Container,
    Wrapper$1 = Wrapper,
    Box$7 = Box;
var Epg = /*#__PURE__*/React__default.forwardRef(function (_ref, containerRef) {
  var children = _ref.children,
      width = _ref.width,
      height = _ref.height,
      sidebarWidth = _ref.sidebarWidth,
      theme = _ref.theme,
      customGlobalStyles = _ref.globalStyles,
      _ref$isRTL = _ref.isRTL,
      isRTL = _ref$isRTL === void 0 ? false : _ref$isRTL,
      _ref$isSidebar = _ref.isSidebar,
      isSidebar = _ref$isSidebar === void 0 ? true : _ref$isSidebar,
      _ref$isTimeline = _ref.isTimeline,
      isTimeline = _ref$isTimeline === void 0 ? true : _ref$isTimeline,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      LoaderComponent = _ref.loader,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var renderLoader = function renderLoader() {
    return LoaderComponent != null ? LoaderComponent : React__default.createElement(Loader, null);
  };

  var epgGlobalStyles = customGlobalStyles != null ? customGlobalStyles : globalStyles;
  return React__default.createElement(ThemeProvider, {
    theme: theme
  }, React__default.createElement(Global, {
    styles: epgGlobalStyles
  }), React__default.createElement(Container$1, Object.assign({
    className: "planby",
    "data-testid": "container",
    width: width,
    height: height,
    ref: containerRef
  }, rest), React__default.createElement(Wrapper$1, null, isSidebar && isTimeline && React__default.createElement(Box$7, {
    isRTL: isRTL,
    width: sidebarWidth,
    height: TIMELINE_HEIGHT,
    left: 0,
    top: 0
  }), isLoading && renderLoader(), children)));
});

var ChannelBox$2 = ChannelBox,
    ChannelLogo$2 = ChannelLogo;
var ProgramBox$2 = ProgramBox,
    ProgramContent$2 = ProgramContent,
    ProgramFlex$2 = ProgramFlex,
    ProgramStack$2 = ProgramStack,
    ProgramTitle$2 = ProgramTitle,
    ProgramText$2 = ProgramText,
    ProgramImage$2 = ProgramImage;
var TimelineWrapper$2 = TimelineWrapper,
    TimelineBox$2 = TimelineBox,
    TimelineTime$2 = TimelineTime,
    TimelineDivider$2 = TimelineDivider,
    TimelineDividers$2 = TimelineDividers;

export { ChannelBox$2 as ChannelBox, ChannelLogo$2 as ChannelLogo, Epg, Layout, ProgramBox$2 as ProgramBox, ProgramContent$2 as ProgramContent, ProgramFlex$2 as ProgramFlex, ProgramImage$2 as ProgramImage, ProgramStack$2 as ProgramStack, ProgramText$2 as ProgramText, ProgramTitle$2 as ProgramTitle, TimelineBox$2 as TimelineBox, TimelineDivider$2 as TimelineDivider, TimelineDividers$2 as TimelineDividers, TimelineTime$2 as TimelineTime, TimelineWrapper$2 as TimelineWrapper, useEpg, useProgram, useTimeline };
//# sourceMappingURL=planby.esm.js.map
